import { useEffect } from 'react';

export function useScrollTopOnMount(): () => void {
  const forceScrollTop = () => {
    document.getElementsByTagName('main')[0]?.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    forceScrollTop();
  }, []);

  return forceScrollTop;
}
